import React, { useEffect, useState } from 'react'
import logo from "../../assets/images/Main-logo.png"
// import Shape1 from "../../assets/images/shape-1.png"
import { Link, NavLink, useLocation } from 'react-router-dom';
import { config } from '../pages/config';
// import LeftNav from '../Reusable/LeftNav';
import { Modal } from 'antd';
import Process from '../pages/Home/Process';
import { max } from 'moment';

const Navbar = () => {

    const [stickyheader, setStickyHeader] = useState(false);
    const [sideMenu, setSideMenu] = useState(false);
    const [home_active, setHomeActive] = useState(false);

    const location = useLocation()


    window.addEventListener("scroll", () => {
        if (window.scrollY > 100) {
            setStickyHeader(true);
        } else {
            setStickyHeader(false);
        }
    });

    // manage home active link
    useEffect(() => {
        if (location.pathname === config.appUrl) {
            setHomeActive(true)
        } else {
            if (home_active)
                setHomeActive(false)
        }
    }, [location.pathname])


    const locationsData = {
        A: ["Antrim"],
        B: ["Ballymena", "Bangor", "Belfast", "Birmingham", "Bournemouth", "Bromsgrove"],
        C: ["Cardiff", "Carrickfergus", "Chippenham", "Cookstown Area", "Corby", "Corsham", "Coventry", "Craigavon", "Crawley"],
        D: ["Abingdon", "Derby", "Didcot", "Dorchester", "Downpatrick", "Wantage"],
        E: ["Enfield"],
        H: ["Hinckley"],
        K: ["Kenilworth", "Kettering", "Kidderminster"],
        L: ["Larne", "Leamington Spa", "Leicester", "Lisburn", "London", "Loughborough", "Lurgan"]
    };

    const company_locations = ["Ballymena", "Bangor", "Belfast", "Birmingham", "Bournemouth", "Bromsgrove", "Leamington Spa", "Leicester", "Larne", "Lisburn", "London", "Loughborough", "Lurgan"];

    const curr_location = localStorage.getItem('ul') || "Location";

    const [openhelp, setopenhelp] = useState(false);

    return (
        <div>
            <header className={`main-header `}>
                <div className="header-top">
                    <div className="top-inner">

                        {/* <div className="single-item">
                            <LeftNav
                                heading="Choose your location"
                                btnText={curr_location}
                                btnIcon={<i className='bi bi-geo-alt-fill me-2'></i>}
                                btnIcon2={<i className='bi bi-chevron-down ms-2'></i>}
                                className="py-1 px-3 bg-black text-danger rounded" >

                                <div className='locations_box'>

                                    {Object.entries(locationsData).map(([initial, cities]) => (
                                        <div key={initial} >
                                            <h2 className="location-initial">{initial}</h2>
                                            <div>
                                                {
                                                    cities.map(loc => {
                                                        return <div key={loc}
                                                            className={`py-2 px-3 location_item rounded 
                                                            bg-white d-inline-block me-2 mb-3 ${curr_location === loc && 'active_location'}`}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                localStorage.setItem('ul', loc)
                                                                window.location.reload()
                                                            }}
                                                        >
                                                            {loc}
                                                        </div>
                                                    })
                                                }
                                            </div>

                                        </div>
                                    ))}
                                    {




                                    }
                                </div>
                            </LeftNav>
                        </div> */}
                        <div className="single-item">
                            <div className="icon">
                                <i className="bi bi-telephone-inbound"></i></div>
                            <h6>
                                <span>
                                    <a href="tel:01162102688" className='text-white'>0116 210 2688</a>
                                    {" / "}
                                    <a href="tel:7380851496" className='text-white'>7380 851496</a>
                                </span>
                            </h6>
                        </div>
                        <div className="single-item header-center-item">
                            <div className="icon">
                                <i className="bi bi-envelope-fill"></i></div>
                            <h6>
                                <span>
                                    <a href="mailto:info@precisiondriving.com" className='text-white'>info@precisiondriving.com</a>
                                </span>
                            </h6>
                        </div>
                        <ul className="share-box clearfix">
                            <li><h6>
                                Follow us :</h6></li>
                            <li><a target="_blank" href="https://www.facebook.com/PrecisionDrivingSchoolLimited"><i className="bi bi-facebook"></i></a></li>
                            <li><a target="_blank" href="https://www.instagram.com/precisiondriving_leicester/"><i className="bi bi-instagram"></i></a></li>
                            {/* <li><a target='_blank' href="#"><i className="bi bi-twitter-x"></i></a></li>
                            <li><a target='_blank' href="#"><i className="bi bi-linkedin"></i></a></li> */}

                        </ul>
                    </div>
                </div>
                <div className={`header-lower ${stickyheader ? "sticky-header" : ""}`}>
                    <div className={`outer-box clearfix`}>
                        <div className='overflow-hidden h-100'>
                            {/* <div className="shape" style={{ backgroundImage: `url(${Shape1})` }}></div> */}
                        </div>
                        <div className="logo-box" style={{ width: "20%" }}>
                            <figure className="logo">
                                <Link to={`${config.appUrl}`}>
                                    <img src={logo} alt="" width="170" />
                                </Link>
                            </figure>
                        </div>
                        <div className="menu-area d-flex justify-content-between" style={{ width: "80%" }} >
                            <div className={`${sideMenu ? 'mobile-menu-box' : ''}`} onClick={() => setSideMenu(false)}>
                                <nav className={`main-menu navbar-expand-md navbar-light ${sideMenu ? 'showMenu' : ''}`}>
                                    <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                        <div className='menu-close-btn' onClick={() => setSideMenu(false)}>
                                            <button><i className='bi bi-x-lg'></i></button>
                                        </div>

                                        <ul className="navigation clearfix">
                                            <li className="current dropdown">
                                                <Link to={`${config.appUrl}`} className={`${home_active && 'active'}`}>Home</Link>
                                            </li>
                                            <li className="dropdown">
                                                <NavLink to={`${config.appUrl}courses`}>Courses</NavLink>
                                            </li>
                                            {/* <li className="dropdown">
                                                <NavLink to={`${config.appUrl}how-to-become-instructor`}>Instructor</NavLink>
                                            </li> */}
                                            <li className="dropdown">
                                                <NavLink to={`${config.appUrl}gallery`}>Media Gallery</NavLink>
                                            </li>
                                            <li className="dropdown">
                                                <NavLink to={`${config.appUrl}contact-us`}>Contact us</NavLink>
                                            </li>
                                            <li className='d-md-none d-block mt-4'>
                                                <div className="btn-box">
                                                    <Link to={`${config.appUrl}book-a-lesson`} className="theme-btn btn-one text-white">Enroll Now</Link>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                            <div className="menu-right ">
                                <a onClick={() => setopenhelp(true)}>
                                    <i className='bi bi-info-circle-fill text-green d-flex align-items-center me-4 fs-4'></i>
                                </a>
                                <div className="search-box-outer search-toggler drop_down_box">
                                    <a href={`#`}
                                        className='text-green' ><i className="bi bi-person"></i></a>
                                    <div className='drop_down'>
                                        <div><a href={config.StudentUrl}
                                            target='_blank' className='text-green' >Login as Student</a></div>
                                        <div><a href={config.ClientUrl.replace('/sign-up', '')}
                                            target='_blank' className='text-green' >Login as Instructor</a></div>
                                    </div>
                                </div>
                                <div className="btn-box">
                                    <Link to={`${config.appUrl}book-a-lesson`} className="theme-btn btn-one text-white">Enroll Now</Link>
                                </div>

                                <div className="mobile-nav-toggler" onClick={() => setSideMenu(true)}>
                                    <i className="icon-bar"></i>
                                    <i className="icon-bar"></i>
                                    <i className="icon-bar"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <Modal
                open={openhelp}
                centered
                onCancel={() => setopenhelp(false)}
                bodyStyle={{ padding: '0' }}
                footer={null}
                width={max}
                className='Help-Modal rounded-3'
            >
                <div className='bg-white p-4'>
                    <Process />
                </div>
            </Modal>
        </div>
    )
}

export default Navbar
